export enum ChannelType {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export enum ConnectionStatus {
  Disconnected = 'DISCONNECTED',
  Connected = 'CONNECTED',
}

export const CHANNEL_NAMESPACE = 'ws';
